import {
    ResultObj,
    allFetch
} from "../Domain";



export type PDIOrderDetailResItem = {
    SIDO_no: string,
    car_type: string,
    contract_name: string,
    cs_id: string,
    ct_id: string,
    custody_user_id: string,
    custody_user_name: string,
    custody_username: string,
    custom_date: string,
    delivery_check_time: string,
    delivery_check_user_name: string,
    delivery_check_userid: string,
    delivery_check_username: string,
    delivery_date: string,
    isdelivery: string,
    license_plate: string,
    licensed_date: string,
    note: string,
    outer_order_number: string,
    outer_order_process: string,
    pdi_order_id: string,
    pdi_pm_id: string,
    predict_delivery_date: string,
}

export type PDIOrderSearchResItem = {
    SIDO_no: string,
    car_type: string,
    contract_name: string,
    cs_id: string,
    ct_id: string,
    custody_user_id: string,
    custody_user_name: string,
    custody_username: string,
    custom_date: string,
    delivery_check_time: string,
    delivery_check_user_name: string,
    delivery_check_userid: string,
    delivery_check_username: string,
    delivery_date: string,
    isdelivery: string,
    license_plate: string,
    licensed_date: string,
    note: string,
    outer_order_number: string,
    outer_order_process: string,
    pdi_order_id: string,
    pdi_pm_id: string,
    predict_delivery_date: string,
}


// 定義 PDIOrderDeliveryUpdateParams 介面
export interface PDIOrderDeliveryUpdateParams {
    pdi_order_id: string;
    predict_delivery_date: string;
    custom_date: string;
}

export const PDIOrderDeliveryUpdate = async (obj: PDIOrderDeliveryUpdateParams = {
    pdi_order_id: "",
    predict_delivery_date: "",
    custom_date: "",
}): Promise<ResultObj> => await allFetch("PDIOrder/PDIOrderDeliveryUpdate", obj);

// 定義 PDIOrderDeliveryCheckParams 介面
export interface PDIOrderDeliveryCheckParams {
    pdi_order_id: string;
    delivery_date: string;
}

export const PDIOrderDeliveryCheck = async (obj: PDIOrderDeliveryCheckParams = {
    pdi_order_id: "",
    delivery_date: "",
}): Promise<ResultObj> => await allFetch("PDIOrder/PDIOrderDeliveryCheck", obj);

// 定義 PDIOrderDeliveryCancelParams 介面
export interface PDIOrderDeliveryCancelParams {
    pdi_order_id: string;
}

export const PDIOrderDeliveryCancel = async (obj: PDIOrderDeliveryCancelParams = {
    pdi_order_id: "",
}): Promise<ResultObj> => await allFetch("PDIOrder/PDIOrderDeliveryCancel", obj);

// 定義 PDIOrderSearchParams 介面
export interface PDIOrderSearchParams {
    outer_order_number: string;
    outer_order_processes: Array<string>;
    custody_user_id: string;
    custody_username: string;
    licensed_date_start: string;
    licensed_date_end: string;
    license_plate: string;
    delivery_date_start: string;
    delivery_date_end: string;
    cs_id: string;
    car_type: string;
    SIDO_no: string;
    has_pdi_procedure: string;
    contract_name: string;
    predict_delivery_date_start: string;
    predict_delivery_date_end: string;
    custom_date_start: string;
    custom_date_end: string;
    note: string;
    page: number;
    num_per_page: number;
}

export const PDIOrderSearch = async (obj: PDIOrderSearchParams): Promise<ResultObj<PDIOrderSearchResItem[]>> =>
    await allFetch("PDIOrder/PDIOrderSearch", obj);

// 定義 PDIOrderDetailParams 介面
export interface PDIOrderDetailParams {
    pdi_order_id: string;
}

export const PDIOrderDetail = async (obj: PDIOrderDetailParams = {
    pdi_order_id: "",
}): Promise<ResultObj<PDIOrderDetailResItem[]>> => await allFetch("PDIOrder/PDIOrderDetail", obj);
